import { api } from './axios'

/**
 * App settings endpoints. Currently used to configure drug-list filter
 * thresholds: slow_moving_days, near_expiry_days, low_stock_default.
 */
export const settingsApi = {
  list: () => api.get('/settings').then((r) => r.data),
  get: (key) => api.get(`/settings/${key}`).then((r) => r.data),
  update: (key, value) =>
    api.patch(`/settings/${key}`, { value: String(value) }).then((r) => r.data),
}
